import { render, staticRenderFns } from "./qsAndAns.vue?vue&type=template&id=bc44eb96&scoped=true&"
import script from "./qsAndAns.vue?vue&type=script&lang=js&"
export * from "./qsAndAns.vue?vue&type=script&lang=js&"
import style0 from "./qsAndAns.vue?vue&type=style&index=0&id=bc44eb96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc44eb96",
  null
  
)

export default component.exports